import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import './HeaderLoggedOut.css';

export default class HeaderLoggedOut extends React.PureComponent {
    public render() {
        return (
            <div className="headerBackground">
                <Container className="loggedOutHeader">
                    <Row>
                        <Col>
                            <img src="/assets/logo_kreis.png" className="headerLogo" alt="kukundo Logo" />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/headerLoggedOut/HeaderLoggedOut.tsx